<template>
  
  <div v-if="items.length > 0" class="item-list" :class="{'demo': getLayout == 'simple' || getLayout == 'album', 'full-height': extendList == true, 'edit-item-list': $route.name == 'Items'}">
    <!-- LIST -->
    <div >
      <div
        class="list-item-body"
        :class="{ 'item-ischosen': checkIfInBuild(item, getBuild) == true }"
        @click="openListItem(item, $event)"
        role="button"
        tabindex="0"
        @keydown.enter="openListItem(item, $event)"
        @keydown.space.prevent="openListItem(item, $event)"
        v-for="(item) in items"
        :key="'A' + item.id">
        <div style="margin-bottom: 5px;" class="list-item-main">
          <div style="position: relative; display: flex;align-items: center; ">
            <div 
              @click.stop="openListItem(item, $event)"
              class="img-list shadow"
              style="cursor: pointer"
              :style="[
              { backgroundImage: item.mainImg ? 'url(' + item.mainImg + ')' : 'url(' + JSON.parse(item.imgUrl)[0] + ')' }
                ]">
              <!-- Enlarge icon -->
              <span class="icon enlarge" @click.stop="enlarge(item)" title="View larger image">
              <img alt="expand" src="../../assets/img/enlarge.png"/></span>
            </div>
            <div class="info-container">
              <div class="info-list">
                <li @click.stop="openListItem(item, $event)" class="item title">
                  <div class="title-row">
                  <div
                    :class="{incompatible: checkPartCompat({compatTable: getCompatLib, type: item.type, asin: item.asin}) == false}"
                    class="list-title"
                    :title="(item.type !== 'cpu' && item.brand ? item.brand + ' ' : '') + item.model">
                    <span v-if="item.type!=='cpu'">{{item.brand}} </span>
                    {{ item.model }}
                    <span style="color: #9198aa;font-size: 16px;" class="icon icon-signal" v-if="item.type =='motherboard' && item.specs && item.specs.WiFi == 'Yes'"></span>
                    <span
                      v-if="releaseYear(item)"
                      class="release-date-mark"
                      v-gixtip="releaseDateTooltip(item)">
                      {{ releaseYear(item) }}
                    </span>
                  </div>
                    <!-- <span style="float: right; position: absolute; right: 0px; margin-right: 9.5%;"  v-if="mode=='edit_delete'">            
                      {{ item.asin }}
                    </span> -->
                    <!-- <a target="_blank" :href="item.amzn_link" v-if="item.amzn_link && item.amzn_link !== 'https://amazon.com/'">
                     Link
                    </a> -->
                  </div>
                </li>
                <li v-if="getLayout == 'simple'" class="item item-desc">
                  {{ itemSummary(item) }}
                </li>
                <div class="tips" style="margin-top: 0px;">
                  <div
                    :class="{incompatible: compat.compatible == false, compatible: compat.compatible == true, warning: compat.compatible == 'warning'}"
                    class="tip "
                    :style="[getListBullets(item, 5).length > 4 
                      ? {maxWidth: '16%'} 
                      : getListBullets(item, 5).length > 3 
                      ? {maxWidth: '19%'} 
                      : {maxWidth: '23%'}]" 
                      style="display: inline-block;"  
                      v-for="(compat, index) in getListBullets(item, 5)"
                      :key="index">
                    <span class="small-bullet key">{{compat.option}}<span v-if="compat.compatible === true || compat.message" class="icon compat-issue-badge" :class="compat.compatible == false ? 'icon-circle-with-cross compat-issue-incompatible' : compat.compatible == 'warning' ? 'icon-warning compat-issue-warning' : 'icon-check compat-issue-compatible'" v-gixtip="compat.message || (compat.compatible === true ? 'Compatible with your build' : '')"></span></span>
                    <span style="min-width: 70px; display: inline-block; position: inherit;text-align: center; text-transform: uppercase; font-size: 16px;" class="small-bullet value">{{ chipNumber(compat) }}<span v-if="chipUnit(compat)" class="chip-unit"> {{ chipUnit(compat) }}</span></span>
                  </div>
                  <div
                    v-if="performanceRankOf(item)"
                    class="tip performance-rank-chip"
                    :class="'performance-rank-chip--' + performanceRankOf(item).tone"
                    tabindex="0"
                    role="img"
                    :aria-label="performanceRankOf(item).ariaLabel"
                    v-gixtip="performanceRankOf(item).tooltip"
                    @click.stop>
                    <span class="performance-rank-head">
                      <span>Performance rank</span>
                    </span>
                    <span class="performance-rank-main">
                      <strong>{{ performanceRankOf(item).label }}</strong>
                      <span>{{ performanceRankOf(item).detail }}</span>
                    </span>
                    <span class="performance-rank-bars" aria-hidden="true">
                      <i
                        v-for="bar in 5"
                        :key="bar"
                        :class="{ 'is-active': bar <= performanceRankOf(item).bars }"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- BUTTONS -->
              <div style="vertical-align: top;" class="list-buttons" @click.stop>
                <div v-if="hasValidPrice(item)" class="price">
                  <li style=" text-align: right; font-weight: 400;list-style: none;">
                    <template v-if="showPrices">
                      <span class="list-price-lockup">
                        <span class="list-price-currency">$</span>
                        <span class="list-price-whole">{{ getPriceWhole(item.amzn_price)}}</span>
                        <span class="list-price-cents"><span>.</span>{{getPriceCents(item.amzn_price)}}</span>
                      </span>
                    </template>
                    <!-- A range reads as an estimate on its own; the label above it
                         was only repeating that. -->
                    <span v-else class="list-typical-price">{{ typicalPriceRange(item) }}</span>
                  </li>
                </div>
                <!-- ADMIN Delete button -->
                <div style="text-align: right" v-if="mode=='edit_delete'">
                    <span
                      @click="updatePart(item)"
                      class="icon icon-edit gc-button smaller-btn"
                      style="margin-top: 2px; padding-top: 3px; "
                    ></span>
                    <span
                      @click="deletePartLocal({type: item.type, id: item.id, model: item.model})"
                      class="icon icon-circle-with-cross gc-button"
                      style="padding-top: 3px; "
                    ></span>
                </div>
                <div v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id]) && (item.type == 'ram' || item.type == 'storage' || item.type == 'gpu' || item.type == 'graphics')"    >
                      <button v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])"  @click="rmFromBuild({item: item, id: item.id}), rmFromMenu({item: item, id: item.id}), getPrice(), trackProduct('remove', item)" style="width: 35% !important;" class="gc-button btn smaller-btn list-remove-button">
                        <span style="margin-top: 6px;padding-left: 0px !important; float: none; font-size: 18px;" class="icon" :class="ifAdded(item)[item.id] > 1 ? 'icon-minus' : 'icon-circle-with-cross'"></span>
                      </button>


                      <!-- NUMBER -->
                      <!-- If ram -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && item.type == 'ram'"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'ram_slots'})}}</div>
                      <div v-if="item.type == 'ram'" :class="{
                          incompatible: checkCompatTable('motherboard', 'ram_slots', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'ram_slots', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number" style="padding-left: 0px !important; float: none; font-size: 16px;"><span>{{getItemValue({item: allMenuOptions.ram.item.contents, field: 'slots'})}}</span></span>
                        </span>
                        <!-- Tooltip -->
                        <div style="margin-left: -75px; margin-top: 20px !important;" v-if="item.type == 'ram' && allMenuOptions.motherboard.item.contents" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              <span style="white-space: nowrap">Empty RAM Slots</span> 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                <span style="margin-left: 5px;">{{hasEmptySlots(item, getBuild, true)}}</span>
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>
                      <!-- If gpu -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && (item.type == 'gpu' || item.type == 'graphics')"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'pci_e_x16'})}}</div>
                      <div v-if="item.type == 'gpu' || item.type == 'graphics'" :class="{
                          incompatible: checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'pci_e_x16', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number" style="padding-left: 0px !important; float: none; font-size: 16px;">
                              <span v-if="allMenuOptions.graphics.item.contents && allMenuOptions.graphics.item.contents.length >0">{{countGpus(getBuild, item.id)}}</span><span v-else>0</span>
                            </span>
                        </span>
                        <!-- Tooltip -->
                        <div style="margin-left: -75px; margin-top: 20px !important;" v-if="(item.type == 'gpu'|| item.type == 'graphics') && allMenuOptions.motherboard.item.contents" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              <span style="white-space: nowrap">Empty PCI-Ex16 Slots</span> 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                {{hasEmptySlots(item, getBuild, true)}}
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>
                    
                      <!-- If sata storage -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && isSataStorage(item)"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'sata_slots'})}}</div>
                      <div v-if="isSataStorage(item)" :class="{
                          incompatible: checkCompatTable('motherboard', 'sata_slots', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'sata_slots', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number" style="padding-left: 0px !important; float: none; font-size: 16px;">
                              <span v-if="allMenuOptions.storage.item.contents && allMenuOptions.storage.item.contents.length >0">{{countStorage(getBuild, 'count', item.id)}}</span><span v-else>0</span>
                              <!-- <span style="position: absolute;white-space:nowrap;bottom:42px;right:0px;font-size: 13px;  color: #434857" v-if="allMenuOptions.motherboard.item.contents">Slots available: <span :style="[hasEmptySlots(item, getBuild, true) >0 ? {color: '#1997c6'}:'']">{{hasEmptySlots(item, getBuild, true)}}</span></span>                       -->
                            </span>
                        </span>
                        <!-- Tooltip -->
                        <div v-if="isSataStorage(item) && allMenuOptions.motherboard.item.contents" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              Empty Sata Slots 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                {{hasEmptySlots(item, getBuild, true)}}
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>

                      <!-- If m.2 storage -->
                      <div v-if="allMenuOptions && allMenuOptions.motherboard.item.contents && isM2Storage(item)"  class="call">{{getCompatibility({item: item, withType: 'motherboard', option: 'm.2_slots'})}}</div>
                      <div v-if="isM2Storage(item)" :class="{
                          incompatible: checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, item, getCompatTable) == false,
                          compatible:   checkCompatTable('motherboard', 'm.2_slots', allMenuOptions, item, getCompatTable) == true
                          }" style="display: inline-block; width: 28%;  text-align: center;">
                        <span v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id])" style="vertical-align: -webkit-baseline-middle; padding: 2px;" class="">
                            <span class="number"  style="padding-left: 0px !important; float: none; font-size: 16px;">
                              <span style="color: #cfd2da" v-if="allMenuOptions.storage.item.contents && allMenuOptions.storage.item.contents.length >0">{{countStorage(getBuild, 'count', item.id)}}</span><span style="color: #cfd2da" v-else>0</span>
                            </span>
                        </span>
                        <!-- Tooltip -->
                        <div v-if="isM2Storage(item) && allMenuOptions.motherboard.item.contents" class="tooltip" :class="{show: getTooltips.includes('max_slots@'+item.id)}">
                            <span style="font-size: 14px; color: #b2b3b4">
                              Empty M.2 Slots 
                              <div :style="{fontWeight: 'bold', color: '#1997c6', display: 'inline-block',  minWidth: '200px;'}">
                                {{hasEmptySlots(item, getBuild, true)}}
                                  <!-- <span style=" color: #9198aa !important"> / {{allMenuOptions.motherboard.item.contents.compat.M_2_Slot}}</span> -->
                              </div>
                            </span>
                        </div>
                      </div>
                      <!-- Buttons -->
                      <div style="display: inline-block; width: 35% !important; margin-left: 1px;  float: right; " @mouseover="showTooltip('max_slots@'+item.id) " @mouseleave="hideTooltip('max_slots@'+item.id)">
                        <button
                          v-if="(typeof(ifAdded(item)) == 'object' && ifAdded(item)[item.id]) "  
                          @click="addToBuild(item), addToMenu(item), getPrice(), trackProduct('add', item)"
                          :disabled="hasEmptySlots(item, getBuild) == false"
                          style=" width: 100% !important" 
                          class="gc-button btn smaller-btn">
                            <span style="padding-left: 0px !important; float: none; font-size: 18px;margin-top: 4px;" class="icon icon-plus"></span>
                        </button>
                      </div>
                  </div>
                <!-- Add to build button -->
                <div v-else class="list-primary-action">
                  <div @mouseover="ifAdded(item) ? hover(item.id, true) : ''" @mouseleave="ifAdded(item) ? hover(item.id, false): ''" 
                    v-if="mode!=='edit_delete' && hasEmptySlots(item, getBuild) == true" class="list-icon check-btn add-to-build-btn" :class="{ checked: ifAdded(item) }">
                    <span
                      v-if="addButtonHovered !== item.id"
                      v-on:click="addToBuild(item), addToMenu(item), setChosen(item), getPrice(), trackProduct('select', item)"
                      class="icon icon-check gc-button smaller-btn list-action-button"
                    ><span class="list-action-label">{{ ifAdded(item) ? 'Added' : 'Add' }}</span></span>
                    <span
                      v-if="ifAdded(item) && addButtonHovered == item.id"
                      v-on:click="unset(item), getPrice(), hover(item.id, false)"
                      class="icon icon-circle-with-cross gc-button smaller-btn list-action-button"
                    ><span class="list-action-label">Remove</span></span>
                  </div>
                  <!-- DISABLED CHECK BUTTON -->
                  <div v-if="mode!=='edit_delete' && hasEmptySlots(item, getBuild) == false" class="list-icon check-btn add-to-build-btn" :class="{ checked: ifAdded(item) }">
                    <span
                      v-if="addButtonHovered !== item.id"
                      class="icon icon-check gc-button smaller-btn disabled list-action-button"
                    ><span class="list-action-label">{{ ifAdded(item) ? 'Added' : 'Add' }}</span></span>
                  </div>
                </div>
                <div v-if="mode!=='edit_delete' && amzn_link(item)" class="list-amazon-action">
                  <a
                    :id="'amzn-button-' + ((item && item.asin) ? item.asin : '')"
                    :href="amzn_link(item)"
                    class="list-amazon-link"
                    target="_blank"
                    rel="nofollow sponsored noopener"
                    aria-label="View on Amazon (opens in a new tab)"
                    @click="trackAmazonClick(item)"
                  >
                    <span>Amazon</span>
                  </a>
                </div>
                <!-- Delete from compare button — only when the item is in the compare list -->
                <div v-if="checkIfInCompareList(item)" style="padding-top: 3px; " class="icon list-icon delete-from-compare-btn">
                  <span
                    style="margin-top: 6px;"
                    v-on:click="removeFromCompare(item)"
                    class="icon icon-minus gc-button"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="vertical-align: bottom; border-radius: 6px 7px 7px 6px" v-if="$route.name == 'cpu' || $route.name == 'gpu'" class="benckmark progress flex-row-reverse" :class="{ isChosen: item.chosen && getLayout !== 'simple' }">
          <div
            class="progress-bar bg-succsess"
            role="progressbar"
            :style="{ width: allItemsLoaded? 100 - (item.performance+20) + '%' : 10}"
            aria-valiemin="0"
            style="background-color: #25272F; border-radius: 0px 6px 6px 0px;"
            aria-valuemax="100"
          >
          </div>
          <div class="performance-bar bar-shadow" :style="{ width: allItemsLoaded ? (item.performance+20) + '%' : 0}" style="text-align: left; padding-left: 5px; color: #191b20; font-weight: bold; font-size: 13px; float: left;">Estimated performance<span style="float: right; padding-right: 10px;">{{(item.performance+20).toFixed(2)}}</span></div>
        </div> -->
      </div>
    </div>
  </div>
  <div style="color: #9198AA; padding-left: 15px; margin-top: 15px; font-size: 16px;" v-else>
    No Results 
  </div>
</template>

<script>
import { mapActions }           from "vuex";
import { mapGetters }           from "vuex";
import { EventBus }             from "../../eventBus";
import {functions }             from "../../functions.js"
import store                    from '../../store'
import { amazonProductUrl, SHOW_PRICES }     from '../../config';
import gixtip                    from '../../directives/tooltip'
import { getBuildContents as getBuildSlotContents } from '../../partOrder'
import analytics                 from '../../services/analytics'
import perf                      from '../../perf'

export default {
  name: "List",
  props: ["items", "search", 'mode', 'new_var', 'layout'],
  directives: {
    gixtip,
  },
  data() {
    return {
      show:                     false,
      extendList:               false,
      addButtonHovered:         false,
      loaded:                   undefined,
      welcomedList:             {
        'Core_Frequency':       'Frequency',
        'Number_of_Cores':      'Cores',
        'Number_of_Threads':    'Threads',
        'processor_generation': 'CPU Gen',
        'socket':               'Socket',
        // 'Integrated_Graphics':  'Int. Graphics',
        //'ram':                  'RAM_Type',
        'ram_speed':            'RAM Speed',
        // 'Max_Memory_Size':      'Max RAM',
        'RAM_Type':             'RAM_Type',
        'Capacity':             'Capacity',
        'RAM_Speed':            'RAM Speed',
        'Number_of_Sticks':     'Mem Slots',
        'Disk_Type':            'Type',
        'size':                 'Size',
        'speed':                'Write Speed',
        'graphics_processor':   'GPU',
        'GPU_clock_speed':      'GPU Clock',
        'memory_clock_speed':   'Mem Clock',
        'graphics_ram_capacity':'Memory',
        'memory_bus_width':     'Bus Width',
        'graphics_interface':   'Interface',
        'connections':          'Connectors',
        // 'VR':                   'VR Support',
        // 'WiFi':                 "WiFi",
        'form_factor':          "Size",
        // 'M_2_Slot':             'M.2_Slot',
        'm_2':                  'M.2',
        'compat_interface':     'Interface',
        'wattage':              'Wattage',
        'energy_rating':        'Rating',
        'tempered_glass':       'Tempered Glass',
        'color':                'Colors',
      },
      digitSpecList:            {
        Frequency:    'GHz',
        Cores:        ' ',
        Threads:      ' ',
        'GPU Clock': 'MHz',
        'Mem Clock': 'MHz',
        'Memory':    'GB',
        'Bus Width': 'Bit',
        Wattage:     'W',
        'RAM Speed': 'MHz',
        'ram_speed': 'MHz',
        'Ram_Speed': 'MHz',
        'Speed':     'MB/s',
      },
      benchMark:                '0',
      play:                     '',
      confirmDelete:            false,
      showConfirm:              false,
      model:                    '',      
    };
  },
  methods: {
    ...mapActions([
      "fetchItems",
      "showTooltip",
      "hideTooltip",
      "setItem",
      "addCompareItem",
      "addToBuild",
      "addToMenu",
      "rmFromMenu",
      "rmFromBuild",
      "removeFromCompare",
      "getPrice",
      "deletePart",
      "setLayout",
      'setSearchFilters',
      'setItems',
      'isCompatible',
      'itemsLoaded'
    ]),
    extend(){
      this.extendList = !this.extendList
      EventBus.$emit('extendListResponse', this.extendList)
    },
    getItemValue:       ({item, field})                           => functions.getItemValue({item, field}),
    checkPartCompat:    ({compatTable, type, asin})               => functions.checkPartCompat({compatTable, type, asin}),
    createCompatTable:  (build)                                   => functions.createCompatTable(build),
    checkCompatTable:   (type, option, build, item, compatTable)  => functions.checkCompatTable(type, option, build, item, compatTable),
    getBuildContents:   (build, type)                             => getBuildSlotContents(build, type),
    getNumericPrice:    (value)                                   => functions.parsePrice(value),
    cents:              (num)                                     => functions.cents(num),
    hasValidPrice(item){
      var price = this.getNumericPrice(item && item.amzn_price)
      return price !== null && price > 0
    },
    typicalPriceRange(item){
      return functions.formatTypicalPriceBand(item && item.amzn_price)
    },
    getPriceWhole(value){
      var numericPrice = this.getNumericPrice(value)
      if(numericPrice === null){
        return ''
      }
      return Math.trunc(numericPrice)
    },
    getPriceCents(value){
      var numericPrice = this.getNumericPrice(value)
      if(numericPrice === null){
        return ''
      }
      return this.cents(numericPrice)
    },
    // Split a chip value into number + unit so the unit can be de-emphasized.
    chipNumber(compat){
      if(!this.digitSpecList[compat.option]){ return compat.value }
      return compat.option.includes('Frequency') ? parseFloat(compat.value).toFixed(2) : parseInt(compat.value)
    },
    chipUnit(compat){
      if(!this.digitSpecList[compat.option]){ return '' }
      return compat.option.includes('Frequency') ? 'GHz' : this.digitSpecList[compat.option]
    },
    hover(id, bool){
      if(bool == true){
        this.addButtonHovered = id
      }
      else {
        this.addButtonHovered = ''
      }
    },
    openListItem(item, event){
      if(event && event.target && event.target.closest){
        var ignoredTarget = event.target.closest('.list-buttons, .enlarge, button, a, input, select, textarea')
        if(ignoredTarget){
          return
        }
      }
      EventBus.$emit('builderListItemOpened')
      this.trackProduct('view', item)
      this.openInSlider(item)
    },
    trackProduct(action, item){
      try { analytics.trackProduct(action, item) } catch (e) { /* best-effort */ }
    },
    openInSlider(item){
      this.setChosen(item)
      if(this.$route.name == 'Items'){
        return
      }
      var navigation = this.open(item)
      this.setLayout('advanced')
      if(this.$parent && typeof this.$parent.popup == 'function'){
        this.$parent.popup(item)
      }
      this.scrollToTopAfterSlider(navigation)
    },
    isReadableValue(value){
      if(value === undefined || value === null){
        return false
      }
      if(typeof value == 'number'){
        return value === value
      }
      var text = String(value).trim()
      var normalized = text.toLowerCase()
      return text !== ''
        && normalized !== 'n/a'
        && normalized !== 'na'
        && normalized !== 'undefined'
        && normalized !== 'null'
        && normalized !== 'nan'
    },
    readableValue(value, suffix){
      if(!this.isReadableValue(value)){
        return ''
      }
      var text = String(value).trim()
      if(!suffix){
        return text
      }
      var normalizedText = text.toLowerCase()
      var normalizedSuffix = suffix.toLowerCase()
      if(normalizedText == normalizedSuffix
        || normalizedText.endsWith(' ' + normalizedSuffix)
        || normalizedText.endsWith(normalizedSuffix)){
        return text
      }
      return text + ' ' + suffix
    },
    releaseSource(item){
      if(!item){ return {} }
      return item.general || item.general_info || item
    },
    releaseDateInfo(item){
      var source = this.releaseSource(item)
      var direct = item || {}
      var date = this.readableValue(source.release_date || direct.release_date)
      return {
        date: this.formatReleaseDate(date),
        precision: this.readableValue(source.release_date_precision || direct.release_date_precision),
        confidence: this.readableValue(source.release_date_confidence || direct.release_date_confidence),
        sourceName: this.readableValue(source.release_date_source_name || direct.release_date_source_name),
        sourceUrl: this.readableValue(source.release_date_source_url || direct.release_date_source_url),
        note: this.readableValue(source.release_date_note || direct.release_date_note),
        checkedAt: this.formatReleaseDate(source.release_date_checked_at || direct.release_date_checked_at)
      }
    },
    releaseYear(item){
      var info = this.releaseDateInfo(item)
      if(!info.date){ return '' }
      var match = String(info.date).match(/\b(19|20)\d{2}\b/)
      return match ? match[0] : ''
    },
    formatReleaseDate(value){
      if(!this.isReadableValue(value)){ return '' }
      var text = String(value).trim()
      var d = new Date(text)
      if(!isNaN(d) && /^\d{4}-\d{2}-\d{2}/.test(text)){
        return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
      }
      if(!isNaN(d) && /^\d{4}-\d{2}/.test(text)){
        return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short' })
      }
      return text
    },
    releaseDateTooltip(item){
      var info = this.releaseDateInfo(item)
      var lines = []
      if(info.date){ lines.push('Release date: ' + info.date) }
      if(info.precision){ lines.push('Precision: ' + info.precision) }
      if(info.confidence){ lines.push('Confidence: ' + info.confidence) }
      if(info.sourceName){ lines.push('Source: ' + info.sourceName) }
      if(info.sourceUrl){ lines.push('Source URL: ' + info.sourceUrl) }
      if(info.note){ lines.push('Note: ' + info.note) }
      if(info.checkedAt){ lines.push('Checked: ' + info.checkedAt) }
      return lines.join('\n')
    },
    itemSummary(item){
      if(!item){
        return ''
      }
      var specs = item.specs || {}
      var compat = item.compat || {}
      var type = item.type == 'gpu' ? 'graphics' : item.type
      var summaryParts = []

      if(type == 'cpu'){
        summaryParts = [
          this.readableValue(specs.Core_Frequency, 'GHz'),
          this.readableValue(specs.Number_of_Cores, 'cores'),
          this.readableValue(specs.Number_of_Threads, 'threads'),
          this.readableValue(compat.socket),
          this.readableValue(compat.ram_speed, 'MHz')
        ]
      }
      else if(type == 'graphics'){
        summaryParts = [
          this.readableValue(specs.GPU_clock_speed, 'MHz core'),
          this.readableValue(specs.memory_clock_speed, 'MHz memory'),
          this.readableValue(specs.graphics_ram_capacity, 'GB VRAM'),
          this.readableValue(specs.memory_bus_width, 'bit'),
          this.readableValue(compat.graphics_interface || specs.graphics_interface)
        ]
      }
      else if(type == 'motherboard'){
        summaryParts = [
          this.readableValue(specs.Socket),
          this.readableValue(compat.processor_generation, 'Gen CPU'),
          this.readableValue(compat.ram),
          this.readableValue(compat.ram_speed, 'MHz'),
          this.readableValue(compat.form_factor),
          this.readableValue(compat.M_2_Slot, 'M.2')
        ]
      }
      else if(type == 'ram'){
        summaryParts = [
          this.readableValue(specs.Capacity, 'GB'),
          this.readableValue(compat.ram_type),
          this.readableValue(specs.RAM_Speed || compat.ram_speed, 'MHz'),
          this.readableValue(compat.number_of_items, 'sticks')
        ]
      }
      else if(type == 'storage'){
        summaryParts = [
          this.readableValue(compat.copacity || specs.Capacity),
          this.readableValue(compat.Disk_Type || specs.Disk_Type),
          this.readableValue(compat.compat_interface),
          this.readableValue(compat.size)
        ]
      }
      else if(type == 'case'){
        summaryParts = [
          this.readableValue(compat.form_factor),
          this.readableValue(specs.color || compat.color),
          this.readableValue(specs.tempered_glass || compat.tempered_glass)
        ]
      }
      else if(type == 'psu'){
        summaryParts = [
          this.readableValue(specs.wattage || compat.wattage, 'W'),
          this.readableValue(specs.energy_rating || compat.energy_rating),
          this.readableValue(compat.form_factor)
        ]
      }

      var summary = summaryParts.filter((part) => part !== '').join(' | ')
      if(summary){
        return summary
      }
      return this.shortDescription(item.description)
    },
    shortDescription(description){
      if(!description){
        return ''
      }
      var text = String(description).replace(/\s+/g, ' ').trim()
      if(text.length <= 92){
        return text
      }
      var cutoff = text.lastIndexOf(' ', 92)
      if(cutoff < 58){
        cutoff = 92
      }
      return text.substring(0, cutoff).trim() + '...'
    },
    getPerfWidth(perf, max){
      var itemPerf = perf
      var maxPerf = max
      if(!itemPerf || !maxPerf){ return '0.00' }
      var score = (itemPerf*100)/maxPerf
      // Floor scored parts at a visible sliver so the bar is never absolutely empty.
      score = Math.max(4, Math.min(100, score))
      return parseFloat(score).toFixed(2)
    },
    getPerfMax(item){
      if(!item){
        return 0
      }
      var storedMax = this.getMaxScores[item.type]
      if(storedMax){
        return storedMax
      }
      if(!this.items || !this.items.length){
        return 0
      }
      var max = 0
      this.items.forEach((part) => {
        if(part && part.type == item.type && part.performance){
          max = Math.max(max, parseFloat(part.performance))
        }
      })
      return max
    },
    getPerfTier(perf, max){
      var score = parseFloat(this.getPerfWidth(perf, max))
      if(score < 34){ return 'list-performance-meter--low' }
      if(score < 67){ return 'list-performance-meter--mid' }
      return 'list-performance-meter--high'
    },
    // Rounded 0-100 performance score (item.performance is already normalized).
    perfScoreOf(item){
      var score = item && item.performance
      if(score == null || isNaN(score)){ return 0 }
      return Math.round(parseFloat(score))
    },
    perfTooltip(item){
      var label = this.$route.name == 'gpu' ? 'GPUs' : 'CPUs'
      return 'Performance ' + this.perfScoreOf(item) + '/100 — a relative score versus other ' + label
        + ' in the catalog. It uses real benchmarks where available and falls back to a spec formula'
        + ' (cores, clocks, architecture). It is a comparison index, not a raw benchmark number.'
    },
    perfAria(item){
      return 'Performance ' + this.perfScoreOf(item) + ' out of 100'
    },
    // Value = performance per dollar (computed in the store from the scraped price
    // for RANKING only). Null for part types without a perf axis or without a price.
    valueIndexOf(item){
      var v = item && item.valueIndex
      return (typeof v == 'number' && isFinite(v)) ? v : null
    },
    valueTierOf(item){
      var v = this.valueIndexOf(item)
      if(v == null || v < 34){ return 'low' }
      if(v < 67){ return 'mid' }
      return 'high'
    },
    valueTooltip(){
      return "Perf/$ = performance per dollar. We weigh this part's performance score against its current"
        + ' price, then rate it 0-100 against the best deal in this category. Higher means more performance'
        + ' for your money.'
    },
    performanceTypeOf(item){
      var type = item && item.type
      if(type != 'cpu' && type != 'gpu' && type != 'graphics'){
        type = this.getCurrentPartType || (this.$route && this.$route.name)
      }
      return type == 'cpu' || type == 'gpu' || type == 'graphics' ? type : null
    },
    performanceRankOf(item){
      if(!item){ return null }
      var type = this.performanceTypeOf(item)
      if(!type){ return null }
      return this.performanceRankings[String(type || '') + ':' + String(item.id)] || {
        label: 'Unranked',
        detail: 'Data pending',
        tone: 'unranked',
        bars: 0,
        ariaLabel: 'Performance rank unavailable',
        tooltip: 'This part does not have enough reliable performance data to rank yet. Price is not included.',
      }
    },
    ifHover(id){
      if(this.hovered[id] == true){
        return true
      }
      else {return false}
    },
    open(item){
      if(this.$route.name !== 'Items'){
        var nextQuery = Object.assign({}, this.$route.query, { view: 'slider', id: item.id })
        var navigate = this.$route.query && this.$route.query.view == 'slider' ? this.$router.replace : this.$router.push
        return navigate.call(this.$router, { path: this.$route.path, query: nextQuery }).catch(()=>{})
      }
      // else {
      //   this.$router.push('editpart?type='+item.type).catch(()=>{})
      // }
      return Promise.resolve()
    },
    scrollToTopAfterSlider(navigation){
      var scroll = () => this.$nextTick(() => this.scrollToTop())
      if(navigation && typeof navigation.then == 'function'){
        navigation.then(scroll)
        return
      }
      scroll()
    },
    scrollToTop() {
      if(typeof window === 'undefined' || typeof window.scrollTo !== 'function'){
        return
      }
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }
      catch (e) {
        window.scrollTo(0,0)
      }
    },
    ifAdded(item){
      var type = ''
      if(item && item.type){
        if(item.type == "gpu"){
            type = 'graphics'
        }
        else {
            type = item.type
        }
      }
      if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents && (type == 'storage' || type == 'ram' || type == 'graphics' || type == 'gpu')){
        var matchIds = {}
        if((typeof(this.getMenuOptions()[type].item.contents == 'object') || typeof(this.getMenuOptions()[type].item.contents == 'object')) && this.getMenuOptions()[type].item.contents.length > 0){
          for (var i = 0; i < this.getMenuOptions()[type].item.contents.length; i++){
            if (this.getMenuOptions()[type].item.contents[i].id == item.id){
              if(!matchIds[item.id]){
                matchIds[item.id] = 0
              }
              matchIds[item.id] = matchIds[item.id] +1
            }
          }
          if(Object.keys(matchIds).length > 0){
            return matchIds
          }
          else {
            return false
            }
        }
      }
      else if(this.getMenuOptions() && this.getMenuOptions()[type] && this.getMenuOptions()[type].item.contents){
        if(item.id == this.getMenuOptions()[type].item.contents.id){
          return true
        }
      }
      return false
    },
    getMenuOptions(){
      return this.allMenuOptions
    },
    getCompatibility({item, withType, option}){
        return store.dispatch('isCompatible', {item: item, withType: withType, option: option})
        .then((res) => {return res})
    },
    getListBullets(item, lim){
      var specsList = {}
      var total = 0
      var limit = lim
      if(window.innerWidth < 900){
        limit = Math.min(limit, 4)
      }
      var specs = item.specs || {}
      var compatData = item.compat || {}
      var addBullet = (key, value) => {
        if(total >= limit || value === 'N/A' || !Object.keys(this.welcomedList).includes(key)){
          return
        }
        if(key == 'connections' && item.type == 'graphics'){
          return
        }
        if(key == 'form_factor' && item.type == 'graphics'){
          return
        }
        specsList[this.welcomedList[key].split('_').join(' ')] = value
        total++
      }

      for (var spec in specs){
        addBullet(spec, specs[spec])
        if(total >= limit){
          break
        }
      }

      if(total < limit){
        for (var compat in compatData){
          addBullet(compat, compatData[compat])
          if(total >= limit){
            break
          }
        }
      }
      // console.log(specsList)
      var specsKeys = Object.keys(specsList)
      var specsArr = []
      specsKeys.map((spc, index) => {
        specsArr.push({
          option: spc,
          value: specsList[spc]
        })
        // Records the compatibility result and, when it fails, the reason
        // message for the chip's tooltip. Mirrors the slider's compat tiles.
        var applyCompat = (withType, option) => {
          this.getCompatibility({item: item, withType: withType, option: option})
          var res = this.checkCompatTable(withType, option, this.allMenuOptions, item, this.getCompatTable)
          specsArr[index].compatible = res
          specsArr[index].message = (res == false || res == 'warning')
            ? functions.getCompatMessage(withType, option, this.allMenuOptions, item, this.getCompatTable)
            : ''
        }
// CPU
        //Socket
        if(item.type == 'cpu' && spc.toLowerCase().includes('socket')){
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'socket')
          }
        }
        // Ram type
        if(item.type == 'cpu' && spc.toLowerCase().includes('ram type')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'ram_type')
          }
          // check ram
          if(this.allMenuOptions && this.allMenuOptions.ram.item.contents){
            applyCompat('ram', 'ram_type')
          }
        }
        // Generation
        if(item.type == 'cpu' && spc.toLowerCase().includes('cpu gen')){
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'processor_generation')
          }
        }
// RAM
        // Ram type
        if(item.type == 'ram' && spc.toLowerCase().includes('ram type')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'ram_type')
          }
          // check cpu
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents){
            applyCompat('cpu', 'ram_type')
          }
        }
        // Capacity
        if(item.type == 'ram' && spc.toLowerCase().includes('capacity')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'max_memory')
          }
          // check cpu
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents){
            applyCompat('cpu', 'max_memory')
          }
        }
        // Ram Speed
        if(item.type == 'ram' && spc.toLowerCase().includes('ram speed')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'ram_speed')
          }
          // check cpu
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents){
            applyCompat('cpu', 'ram_speed')
          }
        }
        // Ram Slots
        if(item.type == 'ram' && spc.toLowerCase().includes('mem slots')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'ram_slots')
          }
        }
//Storage
        // Interface
        if(item.type == 'storage' && spc.toLowerCase().includes('interface')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'interface')
          }
        }
        // Sata Slots
        if(item.type == 'storage' && spc.toLowerCase().includes('sata_slots')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'sata_slots')
          }
        }
//Case
        // Interface
        if(item.type == 'case' && spc.toLowerCase().includes('size')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'form_factor')
          }
          // check psu
          if(this.allMenuOptions && this.allMenuOptions.psu.item.contents){
            applyCompat('psu', 'form_factor')
          }
        }
//Motherboard
        // Interface
        if(item.type == 'motherboard'){
          // check cpu
          // socket
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents && spc.toLowerCase().includes('socket')){
            applyCompat('cpu', 'socket')
          }
          // cpu gen
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents && spc.toLowerCase().includes('cpu gen')){
            applyCompat('cpu', 'processor_generation')
          }
          // ram type
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents && spc.toLowerCase().includes('ram type')){
            applyCompat('cpu', 'ram_type')
          }
          // ram speed
          if(this.allMenuOptions && this.allMenuOptions.cpu.item.contents && spc.toLowerCase().includes('ram speed')){
            applyCompat('cpu', 'ram_speed')
          }
          // check ram
          // ram type
          if(this.allMenuOptions && this.allMenuOptions.ram.item.contents && spc.toLowerCase().includes('ram type')){
            applyCompat('ram', 'ram_type')
          }
          // ram speed
          if(this.allMenuOptions && this.allMenuOptions.ram.item.contents && spc.toLowerCase().includes('ram speed')){
            applyCompat('ram', 'ram_speed')
          }
          // check case
          // size
          if(this.allMenuOptions && this.allMenuOptions.case.item.contents && spc.toLowerCase().includes('size')){
            applyCompat('case', 'form_factor')
          }
        }
//PSU
        // Size
        if(item.type == 'psu' && spc.toLowerCase().includes('size')){
          // check motherboard
          if(this.allMenuOptions && this.allMenuOptions.motherboard.item.contents){
            applyCompat('motherboard', 'form_factor')
          }
          // check case
          if(this.allMenuOptions && this.allMenuOptions.case.item.contents){
            applyCompat('case', 'form_factor')
          }
        }
        // check general
        if(item.type == 'psu' && spc.toLowerCase().includes('wattage')){
          if(this.allMenuOptions){
            applyCompat('general', 'power')
          }
        }
      })
      // console.log(specsArr)
      return specsArr
    },
    async deletePartLocal(part){
      this.model = part.model
      await this.deletePart({type: part.type, id: part.id})
      this.fetchItems(part.type)
    },
    unset(item) {
      if (item !== null) {
        item.contents = null;
        this.rmFromBuild({item: item, id: undefined});
        this.rmFromMenu({item: item, id: undefined});
      }
    },
    updatePart(item){
      this.setItem(item)
      this.$router.push('editpart?type='+item.type).catch(()=>{})
    },
    enlarge(item) {
      EventBus.$emit("enlarge", item);
    },
    getType(){
      this.type = this.$route.path.replace(/\\|\/builder\//g,'') 
      return this.type
    },
    checkIfInCompareList(item) {
      var result = false
      var compare_list = {...this.getCompareList}
      if(compare_list[this.getType()]){
        compare_list[this.getType()].map((itm) => {
          if(itm.id == item.id){
            result =  true
          }
        })
      }  
      return result  
    },
    buildItemId(tp){
      var type = tp
      if(type == 'ram'){
        return 2
      }
      if(type == 'storage'){
        return 3
      }
      if(type == 'gpu' || type == 'graphics'){
        return 4
      }
    },
    normalizedStorageValue(item, field){
      if(!item || !item.compat || item.compat[field] === undefined || item.compat[field] === null){
        return ''
      }
      return String(item.compat[field]).toLowerCase()
    },
    isM2Storage(item){
      if(!item || item.type !== 'storage'){ return false }
      var size = this.normalizedStorageValue(item, 'size')
      var interfaceValue = this.normalizedStorageValue(item, 'compat_interface')
      return size.includes('m.2')
        || size.includes('m2')
        || interfaceValue.includes('m.2')
        || interfaceValue.includes('m2')
        || interfaceValue.includes('nvme')
        || interfaceValue.includes('pci')
    },
    isSataStorage(item){
      return !!(item && item.type == 'storage' && !this.isM2Storage(item))
    },
    countStorageBySlot(items, slotType){
      var total = 0
      if(!items || !items.length){ return total }
      items.forEach((existingItem) => {
        if(slotType == 'm2' && this.isM2Storage(existingItem)){ total++ }
        if(slotType == 'sata' && this.isSataStorage(existingItem)){ total++ }
      })
      return total
    },
    countStorage(build, type, id){
          var storageType = type
          var storage = this.getBuildContents(build, 'storage')
          var sortedStorage = {}
          // Counting occupied ports
          if(storage && storage.length > 0){
            storage.map((itm) => {
              if(!sortedStorage[itm.id]){
                sortedStorage[itm.id] = []
              }
              sortedStorage[itm.id].push(itm)
            })
            if(storageType == 'count' && id){
              if(sortedStorage[id]){
                return sortedStorage[id].length
              }
              return 0
            }
            if(storageType.toLowerCase().includes('m.2')){
              return this.countStorageBySlot(storage, 'm2')
            }
            else return this.countStorageBySlot(storage, 'sata')
          }
          else {return 0}
    },
    countGpus(build, id){
      var gpus = this.getBuildContents(build, 'graphics')
      var sortedGpus = {}
      if(gpus && gpus.length > 0){
         gpus.map((itm) => {
           if(!sortedGpus[itm.id]){
                sortedGpus[itm.id] = []
              }
              sortedGpus[itm.id].push(itm)
         })
        if(sortedGpus[id]){
          return sortedGpus[id].length
        }
        return 0
      }
      return 0
    },
    tooltips(tooltip) {
      if(this.ifTooltip[tooltip] == true){
        return true
      }
      else return false
    },
    hasEmptySlots(item, build, count){
      var type = item.type
      var slotsLeft = 99
      var mb
      // RAM
      if(type == 'ram'){
        var sticksTotal = 0
        var limit = 9
        var ram = this.getBuildContents(build, 'ram')
        mb = this.getBuildContents(build, 'motherboard')
        if(ram && ram.length > 0){
          ram.map((item) => {
            if(item.compat.number_of_items){
              var sticks = parseInt(item.compat.number_of_items)
              sticksTotal += sticks
            }
          })
        }
        if(mb && mb.compat.ram_slots){
          limit = parseInt(mb.compat.ram_slots)
        }
        if(count == true){
          slotsLeft = limit - sticksTotal
          return slotsLeft
        }
        if(sticksTotal >= limit){
            return false
        }
        else {
          return true
        }
      }
      // STORAGE
      if(type == 'storage'){
        var occupiedSata = 0
        var occupiedM2 = 0
        var maxSata =  9
        var maxM2 =  9
        mb = this.getBuildContents(build, 'motherboard')
        var storage = this.getBuildContents(build, 'storage')
        // Setting max ports
        if(mb && mb !==null){
          if(parseInt(mb.compat.M_2_Slot) >0){
            maxM2 = parseInt(mb.compat.M_2_Slot)
          }
          if(parseInt(mb.compat.sata_slots) >0){
            maxSata = parseInt(mb.compat.sata_slots)
          }
        }
        occupiedSata = this.countStorageBySlot(storage, 'sata')
        occupiedM2 = this.countStorageBySlot(storage, 'm2')
        // If no more free sata slots
        if(this.isSataStorage(item)){
          if(count == true){
            slotsLeft = maxSata - occupiedSata
            return slotsLeft
          }
          if(occupiedSata >= maxSata){
            return false
          }
        }
        // If no more free m.2 slots
        if(this.isM2Storage(item)){
          if(count == true){
            slotsLeft = maxM2 - occupiedM2
            return slotsLeft
          }
          if(occupiedM2 >= maxM2){
            return false
          }
        }
        return true
      }
      //GPU
      if(type == 'gpu' || type == 'graphics'){
        var slotsTotal = 0
        var max =  9
        var gpu = this.getBuildContents(build, 'graphics')
        mb = this.getBuildContents(build, 'motherboard')
        if(mb && mb.compat.pci_e_x16){
          max = parseInt(mb.compat.pci_e_x16)
        }
        if(gpu && gpu.length > 0){
          gpu.map(() => {
            slotsTotal += 1
          })
        }
        if(count == true){
          slotsLeft = max - slotsTotal
          return slotsLeft
        }
        if(slotsTotal >= max){
          return false
        }
        else {
          return true
        }
      }
      else {
        return true
      }
    },
    checkIfInBuild(item) {
      if (!item || !this.getBuild) {
        return false
      }
      for (var i = 0; i < this.getBuild.length; i++) {
        var contents = this.getBuild[i].contents
        if (!contents) {
          continue
        }
        if (Array.isArray(contents)) {
          for (var j = 0; j < contents.length; j++) {
            if (contents[j] && contents[j].id == item.id && contents[j].type == item.type) {
              return true
            }
          }
          continue
        }
        if (contents == item || (contents.id == item.id && contents.type == item.type)) {
          return true
        }
      }
      return false
    },
    amzn_link(item) {
      return amazonProductUrl(item && item.asin)
    },
    trackAmazonClick(item) {
      // Push an outbound affiliate-click event to GTM (GTM-WKDJVRS).
      // Amazon conversions only show in the Associates dashboard, so the
      // click is our measurable proxy KPI. Must never throw / block navigation.
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'affiliate_click',
          affiliate: 'amazon',
          part_type: item && item.type,
          asin: item && item.asin,
          model: item && item.model,
          price: SHOW_PRICES ? item && item.amzn_price : null,
        });
      } catch (e) { /* analytics must never break the buy link */ }
      // First-party audience event (was GTM-only before).
      try {
        analytics.trackAmazonClick({
          targetId: item && item.id,
          asin: item && item.asin,
          url: this.amzn_link(item),
          partType: item && item.type,
          model: item && item.model,
          price: SHOW_PRICES ? item && item.amzn_price : null,
          source: 'list',
        })
      } catch (e) { /* best-effort */ }
    },
    async setChosen(item) {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].chosen = false;
      }
      item.chosen = true;
    },
  },
  computed:{
    ...mapGetters([
      "getTooltips",
      "getCompareList",
      "allMenuOptions",
      "getBuild",
      'getLayout',
      'getCurrentPartType',
      'getCompatLib',
      'getCompatTable',
      'allItemsLoaded',
      'getItems',
      'getFetchedItems',
      'getMaxScores'
    ]),
    performanceRankings(){
      var source = Array.isArray(this.getFetchedItems) ? this.getFetchedItems : this.items
      var candidates = (source || []).map((item) => {
        var type = this.performanceTypeOf(item)
        return type && item.type != type ? Object.assign({}, item, { type: type }) : item
      }).filter((item) => this.performanceTypeOf(item))
      if(!candidates.length){ return {} }

      var rankings = {}
      var groups = [
        { items: candidates.filter((item) => item.type == 'cpu'), label: 'CPUs' },
        { items: candidates.filter((item) => item.type == 'gpu' || item.type == 'graphics'), label: 'GPUs' },
      ]

      groups.forEach((group) => {
        if(!group.items.length){ return }
        var ignoreBenchmark = group.label == 'CPUs' && perf.shouldIgnoreBenchmark(group.items)
        var capacities = {}
        group.items.forEach((item) => {
          var key = String(item.type || '') + ':' + String(item.id)
          capacities[key] = perf.rawCapacity(item, { ignoreBenchmark: ignoreBenchmark })
        })
        var scores = group.items.filter((item) => {
          var key = String(item.type || '') + ':' + String(item.id)
          var score = Number(item && item.performance)
          return capacities[key] && capacities[key].raw > 0 && isFinite(score)
        }).map((item) => Number(item.performance)).sort((a, b) => b - a)
        var total = scores.length

        group.items.forEach((item) => {
          var score = Number(item.performance)
          var key = String(item.type || '') + ':' + String(item.id)
          var capacity = capacities[key]
          if(!capacity || capacity.raw <= 0 || !isFinite(score) || !total){
            rankings[key] = {
              label: 'Unranked',
              detail: 'Data pending',
              tone: 'unranked',
              bars: 0,
              ariaLabel: 'Performance rank unavailable',
              tooltip: 'This part does not have enough reliable performance data to rank against the '
                + group.label + ' catalog yet. Price is not included.',
            }
            return
          }
          var rank = scores.findIndex((candidateScore) => candidateScore <= score) + 1
          var percentile = Math.max(1, Math.ceil(rank / total * 100))
          var tier = 'Entry'
          var tone = 'entry'
          if(percentile <= 10){
            tier = 'Enthusiast'
            tone = 'elite'
          }
          else if(percentile <= 35){
            tier = 'Performance'
            tone = 'high'
          }
          else if(percentile <= 70){
            tier = 'Mainstream'
            tone = 'mid'
          }
          var bars = Math.max(1, 6 - Math.ceil(percentile / 20))
          var rankLabel = 'Top ' + percentile + '%'
          rankings[key] = {
            label: rankLabel,
            detail: tier,
            tone: tone,
            bars: bars,
            ariaLabel: 'Performance rank ' + rankLabel + ' of ' + group.label + ', ' + tier + ' tier',
            tooltip: 'Ranked #' + rank + ' of ' + total + ' ' + group.label
              + ' in this catalog by estimated performance. Price is not included.',
          }
        })
      })
      return rankings
    },
    showPrices(){
      return SHOW_PRICES
    },
    getWidth(){
      return window.innerWidth
    }
  },
  
  mounted() {
    EventBus.$on('extendList', () => {
			this.extend()
		})
    EventBus.$on('sortApplied', (items) => {
      console.log('SORT APPLIED ', items)
      this.setItems(items)
    });
    if (this.$route.name == 'Items'){
      this.setLayout('simple')
    }
  },
  updated() {
    this.setSearchFilters(this.getCurrentPartType)
  },
  created(){
    if(this.getCurrentPartType == 'cpu'){
      setTimeout(() => {this.loaded = true}, 100);
    }
    else {this.loaded = undefined}
  },
  beforeDestroy(){
    this.loaded = undefined
  }
};
</script>
<style scoped>
/* Performance bar + its "i" help affordance share one row. */
.perf-row{
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 10px;
    margin: 10px 6px 0;
}
.bar1{
    position: relative;
    height: 6px;
    overflow: hidden;
    border-radius: 999px;
    background: rgba(47, 55, 72, 0.78);
    box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.018),
        0 1px 0 rgba(0, 0, 0, 0.26);
    cursor: help;
}
.perf-caption{
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;
    min-height: 22px;
    padding: 0;
    border: 0;
    background: none;
    color: rgba(145, 152, 170, 0.74);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    line-height: 1;
    text-transform: uppercase;
    cursor: help;
    transition: color 0.18s ease;
}
.perf-caption:hover,
.perf-caption:focus{
    outline: none;
    color: #1997c6;
}
.perf-caption-text{
    line-height: 1;
}
.perf-info{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid rgba(143, 152, 170, 0.42);
    background: transparent;
    color: inherit;
    font-size: 9px;
    font-style: normal;
    font-weight: 700;
    font-family: inherit;
    line-height: 1;
    transition: border-color 0.18s ease, background 0.18s ease;
}
.perf-caption:hover .perf-info,
.perf-caption:focus .perf-info{
    border-color: rgba(25, 151, 198, 0.85);
    background: rgba(25, 151, 198, 0.12);
}

/* Keep the part title constrained to the available detail column. */
.title-row{
    display: flex;
    align-items: center;
    min-width: 0;
}
.item-list .title-row .list-title{
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
}
.bar1 .list-performance-meter{
    position: relative;
    width: 0;
    height: 100%;
    max-width: 100%;
    border: 0;
    border-radius: 999px;
    opacity: 0.88;
    box-shadow: none;
    transition: width 0.5s ease, background 0.3s ease;
}

.list-performance-meter--low {
    background: linear-gradient(90deg, rgba(201, 94, 113, 0.9), rgba(201, 94, 113, 0.72));
}
.list-performance-meter--mid {
    background: linear-gradient(90deg, rgba(197, 185, 90, 0.92), rgba(197, 185, 90, 0.72));
}
.list-performance-meter--high {
    background: linear-gradient(90deg, rgba(22, 169, 137, 0.92), rgba(22, 169, 137, 0.72));
}
.icon-circle-with-cross {
  transition: 0.2s;
  border-color: #e64759 !important;
  color: #e64759 !important;
  background-color: transparent !important;
}
.icon-circle-with-cross:hover {
  background-color: rgba(230, 71, 89, 0.16) !important;
  box-shadow: 0 0 16px rgba(230, 71, 89, 0.14);
}
/* Default CTA styling for the list action buttons (check / cart / +/-). */
.gc-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  height: 37px;
  width: 108px !important;
  border: 1px solid rgba(25, 151, 198, 0.72);
  border-radius: 6px;
  background: rgba(25, 151, 198, 0.06);
  color: #1997c6;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;
}
.gc-button:hover {
  border-color: #16b4ed;
  background: rgba(25, 151, 198, 0.16);
  box-shadow: 0 0 16px rgba(25, 151, 198, 0.14);
  color: #f4f8fb;
}
.small-bullet {
  color: #9198aa;
  font-size: 14px;
}
.incompatible {
  color: #e64759 !important;
  opacity: 0.65;
}
.compatible {
  color: #00bc8c;
}
.compatible .number span {
  color: #cfd2da;
}
.disabled  {
  opacity: 0.65 !important;
}
.tip {
  position: relative;
  margin-top: 3px;
  text-align: center;
  padding: 0px 5px;
  width: -webkit-fill-available;
  /* border: 1px solid #3B3F4C;  */
  /* background-color: #25272F; */
  margin-right: 10px;
  border-radius: 6px;
  padding-bottom: 5px;
  padding-top: 5px;
  min-width: 105px;
  /* box-shadow: inset 0px 0px 2px #9198aa; */
  border: 1px solid #434857;
}
/* Stress incompatible / warning chips with a faint tinted background + border.
   Override the generic .incompatible 0.65 dim so the tint reads cleanly. */
.tip.incompatible {
  border-color: rgba(230, 71, 89, 0.42);
  background: rgba(230, 71, 89, 0.09);
  opacity: 1;
}
.tip.warning {
  border-color: rgba(228, 216, 54, 0.4);
  background: rgba(228, 216, 54, 0.07);
}
.tip.compatible {
  border-color: rgba(0, 188, 140, 0.36);
  background: rgba(0, 188, 140, 0.08);
}
/* Compatibility status icon + tooltip (native title) inline next to the spec
   label: red ✖ for incompatible, yellow ⚠ for warning. */
.tip .compat-issue-badge {
  display: inline-block;
  margin-left: 5px;
  font-size: 12px;
  line-height: 1;
  vertical-align: middle;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 0.15s ease;
}
.tip:hover .compat-issue-badge,
.tip .compat-issue-badge:hover {
  opacity: 1;
}
.compat-issue-badge.compat-issue-incompatible {
  color: #e64759 !important;
}
.compat-issue-badge.compat-issue-warning {
  color: #e4d836 !important;
}
.compat-issue-badge.compat-issue-compatible {
  color: #00bc8c !important;
}
/* Image zoom (magnifier): a corner button revealed on image hover, clickable
   (its click is stopped from the image's open handler in the template). */
.img-list {
  position: relative;
}
.img-list .enlarge {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
}
.img-list:hover .enlarge {
  opacity: 1;
}
.img-list .enlarge:hover {
  background: #1997c6;
  box-shadow: 0 0 12px rgba(25, 151, 198, 0.5);
}
.img-list .enlarge:hover img {
  filter: brightness(0) invert(1);
}
.img-list .enlarge img,
.img-list:hover .enlarge img {
  opacity: 1 !important;
  max-width: 13px !important;
  margin: 0 !important;
}
.list-title {
  color: #CFD2DA; 
}
.tip span {
  display: block;
  text-align: center;
}
.small-bullet.value {
  white-space: nowrap;
  color: #1997c6;
}
/* Units (MHz, GB, W, …) sit slightly dimmer than the number. Keep them inline
   (the generic `.tip span { display: block }` would otherwise push the unit to
   its own line) and let the value stay on one line. */
.tip .chip-unit {
  display: inline;
  opacity: 0.9;
}
.tip .small-bullet.value {
  white-space: nowrap;
}
.icon-minus-hidden {
  display: none;
}
.icon-minus:hover {
  border-color: #e64759 !important;
  background-color: rgba(230, 71, 89, 0.16) !important;
  box-shadow: 0 0 16px rgba(230, 71, 89, 0.14);
  color: #e64759 !important;
}
.inCompareList {
  display: block !important;
}
.inCompareList-hide-add-btn {
  display: none;
}
.checked > span {
  border-color: #1bc98e;  color: #cfd2da !important;
}
.price li{
  color: #e4d836 !important;
  margin-top: -3px;
}
.delete-form-partslist:hover {
  cursor: pointer;
  color: #e64759 !important;
}
.edit {
  cursor: pointer;
}
.tooltip {
  border: 1px solid #434857;
  background-color: #191b20;
  border-radius: 6px;
  text-align: center;

}
.message-box {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  display: inline-block;
  border: 1px solid white;
  height: 150px;
  width: 200px;
  text-align: center;
  padding-top: 3%;
  margin-left: 40%;
}
.view-options {
  margin: 0px;
  float: right;
}
.view-options span {
  color: #434857;
  text-transform: capitalize;
  font-size: 24px !important;
}
.view-options span.active {
  color: #1997c6;
}
.filters span.active {
  color: #1997c6;
}
.filters {
  height: 25px;
  padding: 0px 12px;
  margin: 0px;
  line-height: 25px;
  margin-left: 5px;
}
.filters span {
  vertical-align: middle;
  margin-right: 5px;
}
.filter-option {
  color: #9198aa;
}
.filter-option:hover {
  color: #1997c6;
  cursor: pointer;
}
.list-option:hover, .album-option:hover{
  cursor: pointer;
  color: #1997c6;
}
.demo .list-item-body {
  margin-bottom: 15px;
  padding: 8px 8px;
  padding-top: 10px;
  margin-left: 0px;
  transition: 0.2s;
}

.item-list .list-amazon-icon {
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0;
}
.demo .list-item-body.item-ischosen {
   background-color: #243839 !important;
}
.demo .list-item-body:hover {
  border: 1px solid #9198aa !important;
}
.demo .img-list {
  height: 112px;
  width: 110px;
  min-width: 110px;
}
.title {
  color: #cfd2da !; 
}
.title:hover {
  color: #1997c6 !important;
  cursor: pointer;
}
li.item.title {
  font-size: 22px;
  margin-top: -3px;
}
.album .list-item-body {
  padding: 10px 0px !important;
  display: inline-block;
  width: 230px !important;
  min-height: 210px;
  vertical-align: top;
}
.margin-left{
  margin-left: 20px !important;
}
.album .img-list {
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-bottom: 5px;
}
.album .list-item-body li {
  margin:0px;
  text-align: center;
}
.album .info-list {
  text-align: center;
  margin-left: 0px;
  position: relative;
  width: unset;
}
.item-desc {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 1px;
  max-width: 39vw;
  padding-left: 1px;
}
.list-icon {
  cursor: pointer;
}
.album .list-icon {
  border-radius: 6px;
  float: none;
  position: relative;
  padding: 0px;
  text-align: center;
  border: 1px solid #1A8CB7;
  color: #1A8CB7;
  width: 42%;
  display: inline-block;
  transition: 0.1s;
}
.album .list-icon:hover {
  color: white;
  background-color: #1A8CB7;
}
.album .list-icon:hover .check-btn {
  margin-top: 15px;
}
.album .check-btn {
  margin-left: 95px !important;
}
.demo:hover .benckmark.progress {
  background-color: #434857 !important;
}
.album .buttons-section {
  display: inline-block;
  width: 100%;
  text-align: center;
  margin-top: 8px;
}
.album .add-to-build-btn{
  margin-left: 12px;
  margin-right: 5px;
}
.album .delete-from-build-btn{
  display: none;
  margin-left: 12px;
  margin-right: 5px;
}
.album .add-to-compare-btn{
  margin-left: 5px;
}
.album .delete-from-compare-btn{
  margin-left: 5px;
  display: none;
}
.album .add-to-compare-btn.inCompareList-hide{
  display: none;
}
.album .delete-from-compare-btn.active{
  display: inline-block !important;
}
.album .delete-from-build-btn.active{
  display: inline-block !important;
}
.album .list-item-body:hover .delete-from-build-btn.inBuild{
   display: inline-block;
}
.full-height {
  height: unset !important;
}
.album .delete-from-build-btn span:hover{
   color: #e64759;
}
.tips {
  display: flex;
}

/* Refined builder list layout. Keep the existing data/actions, but make each
   row read as thumbnail, part details, and a quiet action rail. */
.item-list .list-item-body {
  position: relative;
  margin: 0 0 13px !important;
  padding: 9px 12px 8px !important;
  overflow: hidden;
  border: 1px solid rgba(77, 88, 112, 0.72);
  border-radius: 8px;
  background:
    radial-gradient(circle at 18% 0%, rgba(25, 151, 198, 0.08), transparent 30%),
    linear-gradient(135deg, rgba(18, 23, 34, 0.76), rgba(8, 11, 17, 0.72));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.035),
    0 12px 28px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.item-list .list-item-body:hover {
  border-color: rgba(25, 151, 198, 0.58) !important;
  background:
    radial-gradient(circle at 18% 0%, rgba(25, 151, 198, 0.11), transparent 32%),
    linear-gradient(135deg, rgba(20, 26, 38, 0.8), rgba(9, 12, 18, 0.76));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.045),
    0 14px 30px rgba(0, 0, 0, 0.18);
}

.item-list .list-item-body.item-ischosen {
  border-color: rgba(27, 201, 142, 0.58) !important;
  background:
    radial-gradient(circle at 18% 0%, rgba(27, 201, 142, 0.12), transparent 32%),
    linear-gradient(135deg, rgba(17, 29, 33, 0.82), rgba(8, 12, 17, 0.78));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.045),
    inset 2px 0 0 rgba(27, 201, 142, 0.74),
    0 14px 30px rgba(0, 0, 0, 0.18);
}

.item-list .list-item-main {
  margin-bottom: 0 !important;
}

.item-list .list-item-main > div {
  display: grid !important;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
}

.item-list .img-list,
.item-list.demo .img-list {
  box-sizing: border-box;
  width: 95px !important;
  min-width: 95px !important;
  height: 95px !important;
  margin: 0 !important;
  padding: 8px;
  border: 1px solid rgba(202, 210, 224, 0.5);
  border-radius: 8px;
  background-color: #e8edf3;
  background-repeat: no-repeat;
  background-position: center;
  background-origin: content-box;
  background-size: contain;
  box-shadow:
    inset 0 0 22px rgba(17, 24, 38, 0.16),
    inset 0 0 0 1px rgba(255, 255, 255, 0.5),
    0 8px 22px rgba(0, 0, 0, 0.2) !important;
}

.item-list .info-container {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px;
  gap: 12px;
  width: 100%;
  min-width: 0;
  align-items: center;
}

.item-list .info-list {
    min-width: 0;
    overflow: visible;
    padding-right: 4px;
}

.item-list li.item {
  list-style: none;
}

.item-list li.item.title {
  display: block;
  min-width: 0;
  max-width: 100%;
  margin-top: -1px;
  line-height: 1.12;
}

.item-list .list-title {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  color: #d9deea;
  text-overflow: ellipsis;
  text-shadow: 0 0 14px rgba(0, 0, 0, 0.42);
  white-space: nowrap;
}

.item-list .release-date-mark {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  color: rgba(143, 207, 232, 0.9);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-decoration: underline;
  text-decoration-color: rgba(25, 151, 198, 0.48);
  text-decoration-style: dotted;
  text-underline-offset: 3px;
  text-transform: uppercase;
  vertical-align: 2px;
  white-space: nowrap;
}

.item-list .item-desc {
  max-width: 100% !important;
  margin-top: 4px;
  color: rgba(207, 210, 218, 0.76);
  font-size: 14px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.item-list .tips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 8px !important;
}

.item-list .tips .tip {
  display: inline-flex !important;
  /* Don't shrink below the content — shrinking is what squeezed the compat icon
     on top of the label text. The container already wraps to new rows. */
  flex: 0 0 auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: auto !important;
  min-width: 96px;
  max-width: none !important;
  min-height: 42px;
  margin: 0 !important;
  padding: 4px 8px 5px;
  border-color: rgba(82, 93, 118, 0.7);
  background: rgba(8, 11, 17, 0.52);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.item-list .tips .tip .small-bullet.key,
.item-list .tips .tip .small-bullet.value {
  text-align: left !important;
}

.item-list .tips .tip .small-bullet.key {
  /* Keep the label and its compat icon on one row so the icon can't overlap
     the text. inline-flex overrides the generic `.tip span { display:block }`. */
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  color: rgba(174, 181, 198, 0.82);
  font-size: 12px;
  line-height: 1.1;
}

.item-list .tips .tip .small-bullet.value {
  min-width: 0 !important;
  color: #d7dce7;
  font-size: 14px !important;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0;
}

.item-list .tips .tip .chip-unit {
  color: rgba(174, 181, 198, 0.86);
  font-size: 0.92em;
}

.item-list .tips .tip.performance-rank-chip {
  min-width: 132px;
  padding-right: 9px;
  padding-left: 9px;
  cursor: help;
  background:
    radial-gradient(circle at 12% 0%, rgba(45, 188, 232, 0.12), transparent 55%),
    rgba(8, 14, 22, 0.74);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.055),
    0 0 16px rgba(25, 151, 198, 0.065);
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease;
}

.item-list .performance-rank-head {
  display: flex;
  align-items: center;
  color: rgba(174, 181, 198, 0.82);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.1;
  text-transform: none;
  white-space: nowrap;
}

.item-list .performance-rank-bars {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 3px;
  width: 100%;
  height: 3px;
  margin-top: 5px;
}

.item-list .performance-rank-bars i {
  display: block;
  width: auto;
  height: 3px;
  border-radius: 999px;
  background: rgba(91, 103, 123, 0.5);
}

.item-list .performance-rank-bars i.is-active {
  background: #29bce9;
  box-shadow: 0 0 5px rgba(41, 188, 233, 0.42);
}

.item-list .performance-rank-main {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 1px;
  white-space: nowrap;
}

.item-list .performance-rank-main strong {
  color: #dce6ef;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

.item-list .performance-rank-main > span {
  padding-left: 6px;
  border-left: 1px solid rgba(97, 110, 132, 0.48);
  color: #8491a5;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.06em;
  line-height: 1;
  text-transform: uppercase;
}

.item-list .performance-rank-chip--elite {
  border-color: rgba(41, 188, 233, 0.68);
}

.item-list .performance-rank-chip--elite .performance-rank-main strong {
  color: #6edcff;
}

.item-list .performance-rank-chip--high {
  border-color: rgba(40, 210, 169, 0.52);
}

.item-list .performance-rank-chip--high .performance-rank-bars i.is-active {
  background: #38cda7;
  box-shadow: 0 0 5px rgba(56, 205, 167, 0.38);
}

.item-list .performance-rank-chip--mid {
  border-color: rgba(224, 209, 91, 0.5);
}

.item-list .performance-rank-chip--mid .performance-rank-bars i.is-active {
  background: #d7c952;
  box-shadow: 0 0 5px rgba(215, 201, 82, 0.32);
}

.item-list .performance-rank-chip--entry {
  border-color: rgba(93, 109, 134, 0.66);
}

.item-list .performance-rank-chip--entry .performance-rank-bars i.is-active {
  background: #8291a8;
  box-shadow: none;
}

.item-list .performance-rank-chip--unranked {
  border-color: rgba(77, 89, 109, 0.62);
}

.item-list .performance-rank-chip--unranked .performance-rank-main strong,
.item-list .performance-rank-chip--unranked .performance-rank-main > span {
  color: #717d90;
}

.item-list .tips .tip.performance-rank-chip:hover,
.item-list .tips .tip.performance-rank-chip:focus {
  border-color: #1997c6;
  background: rgba(25, 151, 198, 0.09);
  outline: none;
  transform: translateY(-1px);
}

/* Spacing between label and compat icon comes from the key's flex gap now. */
.item-list .tips .tip .small-bullet.key .compat-issue-badge {
  margin-left: 0;
}

.item-list .tips .tip.compatible {
  border-color: rgba(27, 201, 142, 0.34);
  background: rgba(27, 201, 142, 0.07);
}

.item-list .tips .tip.warning {
  border-color: rgba(197, 185, 90, 0.34);
  background: rgba(197, 185, 90, 0.07);
}

.item-list .tips .tip.incompatible {
  border-color: rgba(201, 94, 113, 0.38);
  background: rgba(201, 94, 113, 0.08);
}

.item-list .list-buttons {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 120px;
  min-width: 120px;
  align-items: stretch;
  justify-content: flex-start;
  cursor: default;
}

.item-list .list-buttons > div {
  width: 100%;
  text-align: right;
}

.item-list .list-buttons .price {
  min-height: 24px;
}

.item-list .list-buttons .price li {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-top: 0 !important;
  color: #d7cb51 !important;
  font-size: 20px;
  line-height: 1;
}

.item-list .list-buttons .price li > span {
    color: rgba(174, 181, 198, 0.82) !important;
}

.item-list .list-price-lockup {
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 3px;
  color: #d7cb51 !important;
  line-height: 1;
  white-space: nowrap;
}

.item-list .list-price-currency {
  color: #9198aa !important;
  font-size: 15px;
  line-height: 1;
  margin-top: 1px;
}

.item-list .list-price-whole {
  color: #d7cb51 !important;
}

.item-list .list-price-cents {
  color: #d7cb51 !important;
  font-size: 15px;
  line-height: 1;
  margin-top: 3px;
}

.item-list .list-price-cents span {
  color: #9198aa !important;
}

.item-list .list-buttons .price li > .list-typical-price {
  display: inline-flex;
  align-items: baseline;
  justify-content: flex-end;
  color: #d7cb51 !important;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
}


.item-list .list-buttons .list-amazon-action {
  display: flex;
  justify-content: flex-end;
  margin-top: 0;
}

/* Amazon is a real peer action, not a muted metadata link. It stays slightly
   shorter than Add so the builder action keeps the clearest hierarchy. */
.item-list .list-amazon-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 28px;
  padding: 0 8px;
  border: 1px solid rgba(25, 151, 198, 0.78);
  border-radius: 6px;
  background: rgba(5, 19, 29, 0.55);
  color: #7e9fb4;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1;
  text-decoration: none;
  text-transform: uppercase;
  transition: 0.2s;
}

.item-list .list-amazon-link:hover,
.item-list .list-amazon-link:focus-visible {
  border-color: rgba(66, 207, 250, 0.96);
  background: rgba(25, 151, 198, 0.22);
  box-shadow: 0 0 16px rgba(25, 151, 198, 0.18);
  color: #eefaff;
  outline: none;
  text-decoration: none;
}

.item-list .list-buttons .gc-button {
  width: 100% !important;
  height: 31px;
  border-color: rgba(25, 151, 198, 0.7);
  background: rgba(5, 19, 29, 0.72);
  color: #18a6d8;
  font-size: 18px;
  box-shadow: none;
}

.item-list .list-buttons .gc-button:hover {
  border-color: rgba(34, 187, 236, 0.86);
  background: rgba(25, 151, 198, 0.14);
  box-shadow: 0 0 14px rgba(25, 151, 198, 0.12);
}

.item-list .list-buttons .list-remove-button {
  border-color: rgba(230, 71, 89, 0.55) !important;
  background: rgba(230, 71, 89, 0.08) !important;
  color: #f0b8c0 !important;
}

.item-list .list-buttons .list-remove-button:hover,
.item-list .list-buttons .list-remove-button:focus {
  border-color: rgba(230, 71, 89, 0.86) !important;
  background: rgba(230, 71, 89, 0.16) !important;
  box-shadow: 0 0 16px rgba(230, 71, 89, 0.14) !important;
  color: #ffe9ed !important;
}

.item-list .list-buttons .list-remove-button .icon {
  color: inherit !important;
}

.item-list .list-buttons .add-to-build-btn,
.item-list .list-buttons .add-to-compare-btn {
  margin: 0 !important;
  padding: 0 !important;
}

.item-list .list-buttons .list-action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
  font-size: 15px;
  line-height: 1;
}

/* The icon span carries the icomoon face and .gc-button span floats its
   children left; the label has to opt out of both. */
.item-list .list-buttons .list-action-label {
  float: none;
  margin-top: 0;
  padding-left: 0;
  color: inherit;
  font-family: Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1;
  text-transform: uppercase;
}

.item-list .list-buttons .checked > span {
  border-color: rgba(27, 201, 142, 0.78) !important;
  background: rgba(27, 201, 142, 0.18);
  color: #d9f8ee !important;
}

.item-list .list-buttons .checked > .icon-circle-with-cross {
  border-color: rgba(230, 71, 89, 0.62) !important;
  background: rgba(230, 71, 89, 0.12);
  color: #f0b8c0 !important;
}

.item-list .bar1 {
  height: 5px;
  margin: 7px 0 0;
  background: rgba(43, 51, 67, 0.78);
}

.item-list .perf-row {
  margin: 10px 6px 0;
}

.item-list .perf-row .bar1 {
  height: 6px;
  margin: 0;
  background: rgba(47, 55, 72, 0.78);
}

.item-list .bar1 .list-performance-meter {
  opacity: 0.86;
  transition: width 0.5s ease, background 0.3s ease, opacity 0.18s ease;
}

.item-list .list-item-body:hover .bar1 .list-performance-meter,
.item-list .list-item-body.item-ischosen .bar1 .list-performance-meter {
  opacity: 1;
}

.item-list .list-performance-meter--low {
  background: linear-gradient(90deg, rgb(190, 91, 111), rgb(168, 78, 98));
}

.item-list .list-performance-meter--mid {
  background: linear-gradient(90deg, rgb(180, 169, 86), rgb(158, 148, 75));
}

.item-list .list-performance-meter--high {
  background: linear-gradient(90deg, rgb(18, 157, 130), rgb(14, 132, 110));
}
  @keyframes html-fill{
    100%{
        width: 90%;
    }
}
#css-bar{
    animation: css-fill 1s forwards;
}
@keyframes css-fill{
    100%{
        width: 75%;
    }
}
#js-bar{
    animation: js-fill 1s forwards;
}
@keyframes js-fill {
    100%{
        width: 82%;
    }
}
#jQuery-bar{
    animation: jQuery-fill 1s forwards;
}
@keyframes jQuery-fill{
    100%{
        width: 68%;
    }
}
@media screen and (max-width: 1000px){
  .smaller-btn {
    margin-top: 3px !important;
  }
  .gc-button {
    width: 94px !important;
  }
  .item-list .list-item-main > div {
    grid-template-columns: 96px minmax(0, 1fr);
    gap: 10px;
  }
  .item-list .img-list,
  .item-list.demo .img-list {
    width: 95px !important;
    min-width: 95px !important;
    height: 95px !important;
  }
  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr) 112px;
    gap: 10px;
  }
  .item-list .list-buttons {
    width: 112px;
    min-width: 112px;
  }
  .item-list .bar1 {
    margin: 7px 0 0;
  }

  .item-list .perf-row .bar1 {
    margin: 0;
  }
  
.tip {
    margin-right: 8px;
    padding-left: 8px;
    padding-top: 3px;
    padding-bottom: 3px;
    min-width: 96px;
  }
}
@media screen and (max-width: 863px){
  .item-list .tips {
    display: flex;
    gap: 6px;
    margin-top: 8px !important;
  }
  .item-list .tips .tip {
    min-width: 72px;
    min-height: 42px;
    padding: 4px 7px 5px;
  }
  .item-list .list-item-main > div {
    grid-template-columns: 82px minmax(0, 1fr);
  }
  .item-list .img-list,
  .item-list.demo .img-list {
    width: 76px !important;
    min-width: 76px !important;
    height: 76px !important;
    padding: 6px;
  }
  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr);
  }
  .item-list .list-buttons {
    flex-direction: row;
    width: 100%;
    min-width: 0;
    align-items: center;
    margin-top: 8px;
  }
  .item-list .list-buttons .price {
    flex: 1 1 auto;
    min-height: 0;
  }
  .item-list .list-buttons .gc-button {
    width: 62px !important;
  }
  .item-list .bar1 {
    margin: 7px 0 0;
  }

  .item-list .perf-row .bar1 {
    margin: 0;
  }
  .demo .list-item-body {
    padding-right: 8px !important;
  }
}

@media screen and (min-width: 761px) and (max-width: 900px){
  .item-list {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    height: calc(100vh - 184px);
    padding-right: 0;
    padding-left: 0;
  }

  .item-list .list-item-body {
    max-width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px !important;
    padding: 8px 10px 7px !important;
  }

  .item-list .list-item-main > div {
    grid-template-columns: 76px minmax(0, 1fr);
    gap: 8px;
  }

  .item-list .img-list,
  .item-list.demo .img-list {
    width: 70px !important;
    min-width: 70px !important;
    height: 70px !important;
    padding: 6px;
  }

  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .item-list li.item.title {
    font-size: 20px;
    line-height: 1.12;
  }

  .item-list .item-desc {
    margin-top: 5px;
    font-size: 13px;
    line-height: 1.25;
  }

  .item-list .tips {
    gap: 5px;
    margin-top: 7px !important;
  }

  .item-list .tips .tip {
    flex: 1 1 calc(25% - 4px);
    min-width: 0;
    min-height: 36px;
    padding: 3px 6px;
  }

  .item-list .tips .tip .small-bullet.key {
    font-size: 10px;
  }

  .item-list .tips .tip .small-bullet.value {
    font-size: 12px !important;
  }

  .item-list .list-buttons {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 62px 62px;
    gap: 6px;
    width: 100%;
    min-width: 0;
    margin-top: 7px;
  }

  .item-list .list-buttons > div {
    width: auto;
    min-width: 0;
  }

  .item-list .list-buttons .price {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 31px;
  }

  .item-list .list-buttons .price li {
    justify-content: flex-start;
    font-size: 18px;
  }

  .item-list .list-price-currency,
  .item-list .list-price-cents {
    font-size: 13px;
  }

  .item-list .list-buttons .gc-button {
    width: 100% !important;
    height: 31px;
    font-size: 17px;
  }

  .item-list .bar1 {
    height: 5px;
    margin-top: 7px;
  }

  .item-list .perf-row .bar1 {
    height: 6px;
    margin-top: 0;
  }
}

@media screen and (max-width: 900px){
  .item-list .info-container {
    grid-template-areas:
      "title"
      "desc"
      "actions"
      "specs";
  }

  .item-list .info-list {
    display: contents;
  }

  .item-list li.item.title {
    grid-area: title;
  }

  .item-list .item-desc {
    grid-area: desc;
  }

  .item-list .list-buttons {
    grid-area: actions;
    margin-top: 7px;
    margin-bottom: 1px;
  }

  .item-list .tips {
    grid-area: specs;
    margin-top: 7px !important;
  }
}

@media screen and (min-width: 761px) and (max-width: 900px){
  .item-list .list-item-main > div {
    align-items: start !important;
  }

  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "title actions"
      "desc actions"
      "specs specs";
    column-gap: 12px;
    row-gap: 3px;
    align-items: start;
  }

  .item-list .list-buttons {
    align-self: start;
    justify-self: end;
    display: inline-flex;
    flex-wrap: nowrap;
    gap: 6px;
    width: auto;
    min-width: 0;
    margin: 1px 0 0;
  }

  .item-list .list-buttons > div {
    flex: 0 0 62px;
    width: 62px;
    min-width: 62px;
  }

  .item-list .list-buttons .price {
    flex: 0 0 auto;
    width: auto;
    min-width: 92px;
  }

  .item-list .list-buttons .gc-button {
    width: 62px !important;
    height: 32px;
  }

  .item-list .tips {
    margin-top: 9px !important;
  }

  .item-list .tips .tip {
    flex: 1 1 calc(25% - 4px);
    min-width: 118px;
  }
}

@media screen and (max-width: 760px){
  .item-list {
    height: auto;
    max-height: none;
    padding: 0 0 0.4rem;
    overflow: visible;
  }

  .item-list .list-item-body {
    margin: 0 0 10px !important;
    padding: 8px !important;
    border-radius: 8px;
  }

  .item-list .list-item-main > div {
    grid-template-columns: 66px minmax(0, 1fr);
    gap: 8px;
  }

  .item-list .img-list,
  .item-list.demo .img-list {
    width: 62px !important;
    min-width: 62px !important;
    height: 62px !important;
    padding: 5px;
  }

  .img-list .enlarge {
    display: none;
  }

  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .item-list li.item.title {
    margin-top: 0;
    font-size: 17px;
    line-height: 1.14;
  }

  .item-list .list-title {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .item-list .title-row {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 6px;
  }

  .item-list .item-desc {
    margin-top: 4px;
    max-width: 100% !important;
    color: rgba(174, 181, 198, 0.82);
    font-size: 12px;
    line-height: 1.25;
  }

  .item-list .tips {
    gap: 5px;
    margin-top: 7px !important;
  }

  .item-list .tips .tip {
    flex: 1 1 calc(33.333% - 4px);
    min-width: 0;
    min-height: 36px;
    padding: 3px 6px;
  }

  .item-list .tips .tip .small-bullet.key {
    font-size: 10px;
  }

  .item-list .tips .tip .small-bullet.value {
    font-size: 12px !important;
  }

  .item-list .list-buttons {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 50px 50px;
    gap: 6px;
    width: 100%;
    min-width: 0;
    margin-top: 6px;
  }

  .item-list .list-buttons > div {
    width: auto;
    min-width: 0;
  }

  .item-list .list-buttons .price {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    grid-column: 1 / 2;
    min-height: 30px;
  }

  .item-list .list-buttons .price li {
    justify-content: flex-start;
    font-size: 18px;
  }

  .item-list .list-price-currency {
    font-size: 13px;
  }

  .item-list .list-price-cents {
    font-size: 13px;
  }

  .item-list .list-buttons .gc-button {
    width: 100% !important;
    height: 30px;
    font-size: 17px;
  }

  .item-list .list-buttons .add-to-build-btn,
  .item-list .list-buttons .add-to-compare-btn {
    min-width: 0;
  }

  .item-list .bar1 {
    height: 5px;
    margin-top: 7px;
  }

  .item-list .perf-row .bar1 {
    height: 6px;
    margin-top: 0;
  }
}

@media screen and (max-width: 420px){
  .item-list .list-item-main > div {
    grid-template-columns: 58px minmax(0, 1fr);
    gap: 8px;
  }

  .item-list .img-list,
  .item-list.demo .img-list {
    width: 56px !important;
    min-width: 56px !important;
    height: 56px !important;
  }

  .item-list li.item.title {
    font-size: 17px;
  }

  .item-list .tips .tip {
    flex-basis: calc(50% - 3px);
  }

  .item-list .list-buttons {
    grid-template-columns: minmax(0, 1fr) 46px 46px;
  }
}

@media screen and (max-width: 900px){
  .item-list .list-item-main > div {
    align-items: start !important;
  }

  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr) auto !important;
    grid-template-areas:
      "title actions"
      "desc actions"
      "specs specs" !important;
    align-items: start;
    column-gap: 12px;
    row-gap: 3px;
  }

  .item-list .list-buttons {
    --list-action-size: 72px;
    display: flex !important;
    grid-area: actions;
    flex-direction: row !important;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 6px;
    width: auto !important;
    min-width: max-content;
    margin: 0 !important;
  }

  .item-list .list-buttons .list-primary-action,
  .item-list .list-buttons .add-to-build-btn,
  .item-list .list-buttons .add-to-compare-btn,
  .item-list .list-buttons .delete-from-compare-btn {
    flex: 0 0 var(--list-action-size);
    width: var(--list-action-size) !important;
    min-width: var(--list-action-size);
  }

  .item-list .list-buttons .price {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 78px;
    min-height: 32px;
  }

  .item-list .list-buttons .price li {
    justify-content: flex-end;
  }

  .item-list .list-buttons .gc-button {
    box-sizing: border-box;
    width: 100% !important;
    height: 32px;
    padding-right: 8px;
    padding-left: 8px;
  }

  /* Keep the primary action explicit on touch layouts. The compact control has
     enough room for the icon and short Add/Added label. */
  .item-list .list-buttons .list-action-label {
    display: inline-block;
  }

  .item-list .list-buttons .list-amazon-action {
    flex: 0 0 auto;
    width: auto !important;
  }

  .item-list .list-amazon-link {
    width: auto;
    height: 32px;
    padding: 0 4px;
    border-color: transparent;
    background: none;
    color: #8a97ab;
  }

  .item-list .tips {
    margin-top: 9px !important;
  }
}

@media screen and (min-width: 761px) and (max-width: 900px){
  .item-list .tips .tip {
    flex: 1 1 calc(25% - 4px);
    min-width: 112px;
  }
}

@media screen and (max-width: 760px){
  .item-list .list-buttons {
    --list-action-size: 72px;
  }

  .item-list .tips {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    width: calc(100% + 80px);
    margin-left: -80px;
  }

  .item-list .tips .tip {
    width: 100% !important;
    max-width: none !important;
    min-width: 0;
  }

  .item-list .tips .tip.performance-rank-chip {
    grid-column: 1 / -1;
    min-width: 0;
    max-width: none !important;
  }
}

@media screen and (max-width: 420px){
  .item-list .list-buttons {
    --list-action-size: 72px;
  }
}

@media screen and (max-width: 760px){
  .item-list .list-item-body {
    padding: 10px !important;
  }

  .item-list .list-item-main > div {
    grid-template-columns: 70px minmax(0, 1fr);
    gap: 10px;
    align-items: start !important;
  }

  .item-list .img-list,
  .item-list.demo .img-list {
    width: 62px !important;
    min-width: 62px !important;
    height: 62px !important;
    margin-top: 0 !important;
  }

  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr) auto !important;
    grid-template-areas:
      "title actions"
      "desc actions"
      "specs specs" !important;
    column-gap: 10px;
    row-gap: 4px;
    align-items: start;
  }

  .item-list li.item.title {
    min-height: 0;
    margin: 0 !important;
    font-size: 18px;
    line-height: 1.18;
  }

  .item-list .title-row {
    align-items: start;
    gap: 6px;
  }

  .item-list .list-title {
    display: -webkit-box;
    max-height: 2.36em;
    overflow: hidden;
    line-height: 1.18;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .item-list .item-desc {
    margin-top: 1px;
    font-size: 12px;
    line-height: 1.25;
    white-space: nowrap;
  }

  .item-list .list-buttons {
    align-self: start;
    padding-top: 1px;
  }
}

@media screen and (max-width: 520px){
  .item-list .info-container {
    grid-template-columns: minmax(0, 1fr) !important;
    grid-template-areas:
      "title"
      "desc"
      "actions"
      "specs" !important;
  }

  .item-list .title-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }

  .item-list .list-buttons {
    --list-action-size: 76px;
    width: 100% !important;
    min-width: 0;
    margin-top: 5px !important;
  }

  .item-list .list-buttons .price {
    min-width: 64px;
    margin-right: auto;
  }

  .item-list .list-amazon-link {
    min-width: 88px;
  }

  .item-list .list-buttons .list-primary-action,
  .item-list .list-buttons .add-to-build-btn,
  .item-list .list-buttons .add-to-compare-btn,
  .item-list .list-buttons .delete-from-compare-btn {
    flex-basis: var(--list-action-size);
    width: var(--list-action-size) !important;
    min-width: var(--list-action-size);
  }
}

@media screen and (max-width: 420px){
  .item-list .list-item-main > div {
    grid-template-columns: 62px minmax(0, 1fr);
  }

  .item-list .img-list,
  .item-list.demo .img-list {
    width: 56px !important;
    min-width: 56px !important;
    height: 56px !important;
  }

  .item-list .tips {
    width: calc(100% + 72px);
    margin-left: -72px;
  }
}

</style>
